import { green } from "../colors/index.js";
const primaryColor = (mode)=>'light' === mode ? {
        main: green["600"],
        highContrast: green["800"],
        lowContrast: green["150"]
    } : {
        main: green["500"],
        highContrast: green["300"],
        lowContrast: green["700"]
    };
export { primaryColor };

//# sourceMappingURL=primary.js.map